export default __webpack_public_path__ + "static/media/Extension001.4a33b0aa.png";